import { createFileRoute } from '@tanstack/react-router'
import { BackgroundCheck } from '@/features/background-check'
import { requireBcAccess } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/background-check/')({
  beforeLoad: async () => {
    await requireBcAccess()
  },
  component: BackgroundCheck,
})
